import { Typography } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import SectionChapter from '../../Tutorial/SectionChapter';
import SectionHeader from '../../Tutorial/SectionHeader';
import { FindMoreButton } from '../../Home/HomeFeatures/FindMoreButton';
import { tutorialLinks } from '../../../common/urlLinks';

const SpecialLineageFeature = ({ refs }) => {
    const paste = [
        {
            children: (
                <>
                    <ul>
                        <li>
                            <Typography variant="h6">
                                <FormattedMessage id="grid.type1" />
                            </Typography>
                        </li>
                        <li>
                            <Typography variant="h6">
                                <FormattedMessage id="grid.type2" />
                            </Typography>
                        </li>
                        <li>
                            <Typography variant="h6">
                                <FormattedMessage id="grid.dictando" />
                            </Typography>
                        </li>
                        <li>
                            <Typography variant="h6">
                                <FormattedMessage id="grid.math" />
                            </Typography>
                        </li>
                        <li>
                            <Typography variant="h6">
                                <FormattedMessage id="grid.music" />
                            </Typography>
                        </li>
                    </ul>
                    <a href={tutorialLinks.rulingMenu}>
                        <FindMoreButton />
                    </a>
                </>
            ),
        },
    ];
    return (
        <>
            <SectionHeader
                refs={refs}
                title={'page.home.feature.specialLineage.tag'}
                id={'section-specialLineage'}
                img={`/static/asset/img/features/liniaturi_speciale.png`}
            />
            <SectionChapter
                refs={refs}
                id={'section-specialLineage-section'}
                title={'page.home.feature.specialLineage.description'}
                explanations={paste}
            />
        </>
    );
};

export default SpecialLineageFeature;
